import {restoreOrderSheetDataByStorage} from '@web/actions/restoreState'
import {CashReceiptIssueType, CashReceiptIssueUsage} from '@web/core/constants'
import makeSlice from '@web/slices/cashReceipt/sliceMaker'

import {initPaymentMethodManagement} from '../../actions'

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(initPaymentMethodManagement.fulfilled, (state, {payload: {response}}) => {
                const {prevPaymentMethodInfo} = response

                const {cashReceipt} = prevPaymentMethodInfo

                // 이전 발행기록이 있을경우 saved에 이전발행유형 저장
                state.issueType.saved = cashReceipt?.usageType ?? null
                state.issueType.current = cashReceipt?.issueType ?? null

                state.prevUsageType = cashReceipt?.usageType ?? CashReceiptIssueUsage.PERSONAL_INCOME_TAX

                // 이전발행유형이 개인일경우 최근선택한 하위유형에 저장
                if (cashReceipt?.usageType === CashReceiptIssueUsage.PERSONAL_INCOME_TAX) {
                    state.issueType.prev = cashReceipt?.issueType ?? CashReceiptIssueType.PR_CELL_PHONE_NUMBER
                }
                if (cashReceipt?.issueNumber) {
                    switch (cashReceipt.issueType) {
                        case CashReceiptIssueType.BUSINESS_REGISTRATION_NUMBER: {
                            state.issueNumber[cashReceipt.issueType] = [
                                cashReceipt.businessRegistrationNumberFirst ?? '',
                                cashReceipt.businessRegistrationNumberSecond ?? '',
                                cashReceipt.businessRegistrationNumberThird ?? '',
                            ]

                            break
                        }
                        case CashReceiptIssueType.PR_CASH_RECEIPT_CARD_NUMBER: {
                            state.issueNumber[cashReceipt.issueType] = [
                                cashReceipt.cashReceiptCardNumberFirst ?? '',
                                cashReceipt.cashReceiptCardNumberSecond ?? '',
                                cashReceipt.cashReceiptCardNumberThird ?? '',
                                cashReceipt.cashReceiptCardNumberFourth ?? '',
                            ]
                            break
                        }
                        case CashReceiptIssueType.PR_CELL_PHONE_NUMBER: {
                            state.issueNumber[cashReceipt.issueType] = [
                                cashReceipt.mobilePhoneNumberFirst ?? '',
                                cashReceipt.mobilePhoneNumberSecond ?? '',
                                cashReceipt.mobilePhoneNumberThird ?? '',
                            ]
                            break
                        }
                    }
                }
            })
            .addCase(restoreOrderSheetDataByStorage.fulfilled, (_, {payload}) => {
                return payload.cashReceipt
            })
    },
})

export default slice.reducer
